var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.6916 0.5 0 3.19164 0 6.50004C0 9.80844 2.6916 12.5 6 12.5C9.3084 12.5 12 9.80844 12 6.50004C12 3.19164 9.3084 0.5 6 0.5ZM6 11.4091C3.29309 11.4091 1.09091 9.20691 1.09091 6.50004C1.09091 3.79316 3.29309 1.59091 6 1.59091C8.70691 1.59091 10.9091 3.79316 10.9091 6.50004C10.9091 9.20691 8.70687 11.4091 6 11.4091Z",
    fill: "#0074FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99959 3.0459C5.59864 3.0459 5.27246 3.3723 5.27246 3.7735C5.27246 4.17434 5.59864 4.50044 5.99959 4.50044C6.40053 4.50044 6.72672 4.17434 6.72672 3.7735C6.72672 3.3723 6.40053 3.0459 5.99959 3.0459Z",
    fill: "#0074FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99956 5.59082C5.69832 5.59082 5.4541 5.83504 5.4541 6.13627V9.409C5.4541 9.71024 5.69832 9.95446 5.99956 9.95446C6.30079 9.95446 6.54501 9.71024 6.54501 9.409V6.13627C6.54501 5.83504 6.30079 5.59082 5.99956 5.59082Z",
    fill: "#0074FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBlue);
export default __webpack_public_path__ + "static/media/question-blue.7679ac8d6b00423a66d696e5de725a35.svg";
export { ForwardRef as ReactComponent };